import { useContext } from 'react';

import NotificationsContext, { NotificationsContextValue } from 'src/contexts/NotificationsContext';

const useNotifications = (): NotificationsContextValue => useContext(NotificationsContext);

export default useNotifications;
